import { FunctionComponent } from "react";
import { setData } from "rivals/shared/utils/qa";
import styles from "./AddOnSuccess.module.scss";
import strings from "./strings";
import { OwnProps } from "./types";

const {
  renewing,
  subscription,
  upcomingBillingSummary,
  upcomingBillingTitle
} = strings;

const AddOnSuccess: FunctionComponent<OwnProps> = ({ upcomingBilling }) => {
  if (!upcomingBilling) {
    return null;
  }

  const dataPhilter = "addon-success-upcoming-billing";
  const bundleAddOn = upcomingBilling.addOns.find(o => o.type === "BUNDLE");
  const filteredAddOns = upcomingBilling.addOns.filter(
    o => o.type !== "BUNDLE"
  );

  const BillingSuccessRow = (
    style: string,
    title: string,
    price: string,
    subtitle?: string
  ): JSX.Element => {
    return (
      <div key={`${title}-${price}`}>
        <div
          className={styles[`billingInformationRow${style}`]}
          {...setData(dataPhilter, `receipt-row-${title}`)}
        >
          <div className={styles.label}>{title}</div>
          <div className={styles.amount}>{price}</div>
        </div>
        {subtitle && <div className={styles.rowSubtitle}>{subtitle}</div>}
      </div>
    );
  };

  const successCard = (
    <>
      <div className={styles.upcomingBillingTitle}>{upcomingBillingTitle}</div>
      <div
        className={styles.upcomingBillingText}
        {...setData(dataPhilter, `summary`)}
      >
        {upcomingBillingSummary(
          upcomingBilling.subscription.plan,
          upcomingBilling.pricing.nextBillingDate
        )}
      </div>
      <div
        className={styles.billingInformation}
        {...setData(dataPhilter, `receipt`)}
      >
        {BillingSuccessRow(
          "",
          `${renewing} ${upcomingBilling.pricing.nextBillingDate}`,
          ""
        )}
        {BillingSuccessRow(
          "",
          `${upcomingBilling.subscription.plan} ${subscription}`,
          upcomingBilling.subscription.price,
          upcomingBilling.subscription.name
        )}
        {!!bundleAddOn && (
          <>
            {BillingSuccessRow("", "Spy on Your Rival Bundle", "")}
            {bundleAddOn.spyBundleData &&
              bundleAddOn.spyBundleData.bundledSites &&
              !!bundleAddOn.spyBundleData.bundledSites.length &&
              BillingSuccessRow(
                "AddOn",
                `${bundleAddOn.spyBundleData.bundledSites
                  .map(o => o.friendlyName)
                  .join(" . ")}`,
                `$${bundleAddOn.price}`
              )}
          </>
        )}

        {!!filteredAddOns.length && (
          <>
            {BillingSuccessRow("", "Add Ons", "")}
            {filteredAddOns.map((addon, index) =>
              BillingSuccessRow(
                "AddOn",
                `${index + 1}: ${addon.lineItem}`,
                `$${addon.price}`
              )
            )}
          </>
        )}
        {BillingSuccessRow("", "Tax", `$${upcomingBilling.pricing.tax}`)}
        {BillingSuccessRow(
          "Total",
          "Total",
          `$${upcomingBilling.pricing.total}`
        )}
      </div>
    </>
  );

  return (
    <div className={styles.addOnSuccess} {...setData(dataPhilter, "card")}>
      {successCard}
    </div>
  );
};

export default AddOnSuccess;
